/**
 * t344u: the Search page before you type (desktop, phone web and the app): your recent searches on this device and
 * a few quick jumps, instead of "Type at least two characters".
 */
export const RECENT_SEARCHES_MAX = 8;
export const recentSearchesKey = (ws: string) => `hub.search.recent.${ws}`;

/** Newest first, case-insensitive de-duplication, trimmed, at most RECENT_SEARCHES_MAX; shorter than 2 is ignored. */
export function pushRecentSearch(list: readonly string[], q: string, max = RECENT_SEARCHES_MAX): string[] {
  const t = q.trim().replace(/\s+/g, ' ');
  if (t.length < 2) return [...list];
  return [t, ...list.filter(x => x.toLowerCase() !== t.toLowerCase())].slice(0, max);
}

/** Parses what was stored; anything unexpected reads as no recents. */
export function parseRecentSearches(raw: string | null | undefined): string[] {
  if (!raw) return [];
  try { const v: unknown = JSON.parse(raw); return Array.isArray(v) ? v.filter((x): x is string => typeof x === 'string').slice(0, RECENT_SEARCHES_MAX) : []; }
  catch { return []; }
}

/** Where people usually go. `web` is the web path; `app` the app route. */
export const SEARCH_QUICK_JUMPS: readonly { id: string; label: string; web: string; app: string }[] = [
  { id: 'people', label: 'People', web: '/people', app: '/people' },
  { id: 'tasks', label: 'Tasks', web: '/tasks', app: '/tasks' },
  { id: 'issues', label: 'Issues', web: '/incidents', app: '/issues' },
  { id: 'calendar', label: 'Calendar', web: '/calendar', app: '/calendar' },
  { id: 'announcements', label: 'Announcements', web: '/announcements', app: '/announcements' },
  { id: 'help', label: 'Help & knowledge base', web: '/help', app: '/help' },
];
